import axios from "axios";
import HttpError from "../utils/errors/http-error";

const responseStorage = {};

class Http {
    constructor(baseURL) {
        this.iaxios = axios.create({
            defaultInterceptors: true,
            baseURL,
            timeout: 40000,
        });
        this.iaxios.all = axios.all;
        this.iaxios.isCancel = axios.isCancel;
    }

    getRequest(path, params = {}, config = {}, storage = {key: ""}) {
        return this.handleRequest(
            () =>
                this.iaxios.get(path, {
                    params,
                    ...config,
                }),
            storage
        );
    }

    postRequest(path, data, config = {}) {
        return this.handleRequest(() =>
            this.iaxios.post(path, data, {
                ...config,
            })
        );
    }

    putRequest(path, data, config = {}) {
        return this.handleRequest(() =>
            this.iaxios.put(path, data, {
                ...config,
            })
        );
    }

    allRequest(requests) {
        return this.iaxios.all(requests);
    }

    async handleRequest(request, storage = {key: ""}) {
        try {
            if (storage.key) {
                const data = responseStorage[storage.key]; // get from cache
                if (data) {
                    return Promise.resolve(data);
                } else {
                    const result = await request();
                    responseStorage[storage.key] = result.data; // save cache
                    return Promise.resolve(result.data);
                }
            }
            const result = await request();
            return Promise.resolve(result.data);
        } catch (error) {
            throw new HttpError(error);
        }
    }
}

export default Http;
